import { render, staticRenderFns } from "./UnloadedItems.vue?vue&type=template&id=3d6b3f82&scoped=true"
import script from "./UnloadedItems.vue?vue&type=script&lang=ts"
export * from "./UnloadedItems.vue?vue&type=script&lang=ts"
import style0 from "./UnloadedItems.vue?vue&type=style&index=0&id=3d6b3f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b3f82",
  null
  
)

export default component.exports